import { render, staticRenderFns } from "./ServerError.vue?vue&type=template&id=b23a4b06&scoped=true"
import script from "./ServerError.vue?vue&type=script&lang=js"
export * from "./ServerError.vue?vue&type=script&lang=js"
import style0 from "./ServerError.vue?vue&type=style&index=0&id=b23a4b06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23a4b06",
  null
  
)

export default component.exports